import HelperFunctions from '../../global/HelperFunctions';
import { getNames, registerLocale } from 'i18n-iso-countries';
import localeEN from 'i18n-iso-countries/langs/en.json';
import localeNL from 'i18n-iso-countries/langs/nl.json';

registerLocale(localeNL);
registerLocale(localeEN);

const appLocale = 'nl';

export function getCountryOptions(lang: string) {
    const allLanguagesAsObject = getNames(lang ?? appLocale);

    return Object.keys(allLanguagesAsObject)
        .map((key) => {
            return {
                value: key,
                label: allLanguagesAsObject[key],
            };
        })
        .sort(HelperFunctions.sortByString('label'));
}
